import { render, staticRenderFns } from "./Movimiento_Tipo.vue?vue&type=template&id=1c562534"
import script from "./Movimiento_Tipo.vue?vue&type=script&lang=js"
export * from "./Movimiento_Tipo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports